import React from 'react';
import { Card } from './ui/card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const KpiCard = ({ label, value, sub, delta, deltaLabel, tone = 'neutral', status, icon: Icon, onClick, actionHint }) => {
  const toneClass = tone === 'good' ? 'delta-good' : tone === 'bad' ? 'delta-bad' : tone === 'warn' ? 'delta-warn' : 'delta-neutral';
  const statusColor = status === 'good' ? 'hsl(var(--success))' : status === 'warn' ? 'hsl(var(--warning))' : status === 'bad' ? 'hsl(var(--danger))' : null;
  const clickable = typeof onClick === 'function';
  return (
    <Card
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      className={`rounded-xl border bg-card p-4 shadow-sm transition-shadow duration-200 hover:shadow-md ${clickable ? 'cursor-pointer hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40' : ''}`}
      data-testid="kpi-card">
      <div className="flex items-start justify-between gap-3">
        <span className="text-xs text-muted-foreground flex items-center gap-1.5">
          {statusColor && <span className="h-2 w-2 rounded-full shrink-0" style={{ background: statusColor }} data-testid="kpi-status-dot" aria-hidden="true" />}
          {label}
        </span>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <div className="mt-2 text-2xl md:text-[28px] leading-tight font-semibold tabular" style={statusColor ? { color: statusColor } : undefined} data-testid="kpi-card-value">{value}</div>
      {(sub || delta) && (
        <div className="mt-2 flex items-center gap-2 text-xs" data-testid="kpi-card-delta">
          {delta !== undefined && delta !== null && (
            <span className={`inline-flex items-center gap-0.5 font-medium ${toneClass}`}>
              {tone === 'good' ? <ArrowUpRight className="h-3.5 w-3.5" /> : tone === 'bad' ? <ArrowDownRight className="h-3.5 w-3.5" /> : null}
              {delta}
            </span>
          )}
          {sub && <span className="text-muted-foreground">{sub}</span>}
          {deltaLabel && <span className="text-muted-foreground">{deltaLabel}</span>}
        </div>
      )}
      {clickable && actionHint && <div className="mt-2 text-[11px] font-medium text-primary/80">{actionHint}</div>}
    </Card>
  );
};
